import { useMemo } from 'react'

export const useZoomGallery = (images: string[], activeImage: string) => {
  const gallery = useMemo(() => {
    const normalized = images.map((item) => item.trim()).filter(Boolean)
    return Array.from(new Set(normalized))
  }, [images])

  const resolvedImage = gallery.includes(activeImage) ? activeImage : (gallery[0] ?? '')
  return { gallery, resolvedImage }
}
